import styled from 'styled-components'

import { applyIPadOnlyStyle } from 'helpers/css'

export const Container = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    ${({ background }) =>
        applyIPadOnlyStyle(`background:${background}`, {
            orientation: 'both',
            min: 0,
            max: 1370,
        })}
`
